<button [disabled]="form" type="button" class="" (click)="continue">
  Aceptar
</button>
